<h3>Terminate Field Worker</h3>
<p>
	WARNING: Confirm this field worker has received their last paycheck before you save
	this field worker's status as "Terminated."
</p>

<div mat-dialog-actions fxLayoutAlign="end">
	<button mat-button type="button" color="primary" (click)="cancel()" mat-dialog-close>
		Cancel
	</button>
	<button mat-button type="button" color="primary" (click)="accept()" mat-dialog-close>
		Accept
	</button>
</div>